import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core';
import Call from '@material-ui/icons/Call';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
}));
export default function ConfirmDialog({ row, deleteRow, axiosConfig, tennantName }) {
    const clientType = row.clientType;
    const clientId = row.clientId;
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [clientInfo, setclientInfo] = React.useState('');
    const callforclient = clientInfo.ClientInfo;
    const UserinfoCRC = clientInfo.Userinfo;
    const clientCall = callforclient && callforclient.primarycontMobnumber;
    const userinfoCall = UserinfoCRC && UserinfoCRC.mobileNumber;
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    //console.log('ROW', row);
    const fetchClientDetails = () => {
        const apiUrl = `${CommonConfig.dev.baseUrl}/api/auth/call-info?userType=${clientType}&id=${clientId}&tennantName=${tennantName}`;
        axios
            .get(apiUrl, axiosConfig)
            .then((response) => {
                //console.log("response71", response);
                setclientInfo(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    const handleClickOpen = () => {
        setOpen(true);
        //console.log('OPEN : ', row);
        fetchClientDetails();
    };

    const handleClose = () => {
        setOpen(false);
    };
    const call = () => {
        setShowLoader(true);
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/call?userPhone=${userinfoCall}&salesPhone=${clientCall}`, axiosConfig)
            .then((response) => {
                //console.log('THE CALL : ', response);
                if (response.data.message === 'Phone call incoming!') {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        setSuccessPop(false);
                    }, 1500);
                }
            })
            .catch((error) => {
                //   ////console.log(error);
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleOk = () => {
        deleteRow(row);
        setOpen(false);
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Phone call incoming!" /> : null}
            {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}

            <Tooltip title="Call" onClick={handleClickOpen}>
                <IconButton aria-label="Call Details">
                    <Call />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Client Details
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Name : {clientInfo.ClientInfo && clientInfo.ClientInfo.firstName}
                        <br />
                        last Name : {clientInfo.ClientInfo && clientInfo.ClientInfo.lastName}
                        <br />
                        {/* Contact No : {clientInfo.ClientInfo && clientInfo.ClientInfo.primaryconNum}
                        <br /> */}
                        Mobile No : {clientInfo.ClientInfo && clientInfo.ClientInfo.primarycontMobnumber}
                        <br />
                        Email : {clientInfo.ClientInfo && clientInfo.ClientInfo.primarycontEmailid}
                        <br />
                        City : {clientInfo.ClientInfo && clientInfo.ClientInfo.addressId.city},
                        {clientInfo.ClientInfo && clientInfo.ClientInfo.addressId.stateId.stateName}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.button}>
                        Cancel
                    </Button>
                    <Button onClick={() => call()} variant="outlined" color="primary" size="small" className={classes.button} autoFocus>
                        Call
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
